// Web端多分校基础配置, 请保持与其它分校目录文件一致
import { requireFiles } from 'common/utils'

export default requireFiles(require.context('./', true, /\.js$/))
